<template>
  <div class="row" v-if="loggedInUser && loggedInUser.role">
    <div class="dashboard-box col-md-6 mb-5 col-xl-3">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center">
          <i class="ag-icon ag-icon_managecompanies mr-2"></i>
          <span v-role="[Roles.AGMSAdmin]">Global</span>
          <span v-role="[Roles.PartnerAdmin]">{{ this.partner ? this.partner.name : 'Partner' }}</span>
          <span v-role="[Roles.CompanyAdmin]">{{ company.companyName }}</span>
          <span v-role="[Roles.SiteAdmin, Roles.SiteAudit]">{{
    site.value
  }}</span>
          <span v-role="[Roles.GroupAdmin, Roles.GroupAudit]">{{
    group.value
  }}</span>
        </h6>
        <Company></Company>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-5 col-xl-3" v-if="loggedInUser.role !== Roles.PartnerAdmin">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="ag-icon ag-icon_alert mr-2"></i>{{ $t("alertSummary") }}
          </div>
          <small>({{ $t("last7days") }})</small>
        </h6>
        <Alert></Alert>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-5 col-xl-3" v-if="loggedInUser.role === Roles.PartnerAdmin">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="ag-icon ag-icon_alert mr-2"></i>Events Trend
          </div>
        </h6>
        <EventsTrend></EventsTrend>
      </div>
    </div>

    <div class="dashboard-box col-md-6 mb-5 col-xl-3">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="ag-icon ag-icon_hash-inspection mr-2"></i>{{ $t("knownThreats") }}
          </div>
          <small>({{ $t("last7days") }})</small>
        </h6>
        <known-threats></known-threats>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-5 col-xl-3">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center">
          <i class="ag-icon ag-icon_shield_blue mr-2"></i>Protected Endpoints
        </h6>
        <protected-agents></protected-agents>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-2 col-xl-3" v-role="[
    Roles.SiteAudit,
    Roles.GroupAdmin,
    Roles.CompanyAdmin,
    Roles.GroupAudit,
    Roles.SiteAdmin,
  ]">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center">
          <i class="ag-icon ag-icon_assets mr-2"></i>{{ $t("licences") }}
        </h6>
        <licences></licences>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-2 col-xl-3" v-if="loggedInUser.role == Roles.PartnerAdmin">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center">
          <i class="ag-icon ag-icon_assets mr-2"></i>Licenses
        </h6>
        <admin-licences></admin-licences>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-2 col-xl-3">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center">
          <i class="ag-icon ag-icon_barchart_blue mr-2"></i>{{ $t("NumberBlocksTime") }}
        </h6>
        <blocks-over-time></blocks-over-time>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-2 col-xl-3">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="ag-icon ag-icon_computergroup_blue mr-2"></i>{{ $t("Top5Groups") }}
          </div>
          <small>({{ $t("last7days") }})</small>
        </h6>
        <top5-groups></top5-groups>
      </div>
    </div>
    <div class="dashboard-box col-md-6 mb-2 col-xl-3">
      <div class="ag-card_chart h-100">
        <h6 class="chartTitle p-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="ag-icon ag-icon_assets mr-2"></i>Top 5 Endpoint Host Names
          </div>
          <small>({{ $t("last7days") }})</small>
        </h6>
        <top5-computers></top5-computers>
      </div>
    </div>
    <div class="col-md-12 mb-4 text-right">
      <span class="now">{{ $t("pageCreatedAt") }} {{ now }} UTC</span>
    </div>
  </div>
  <iframe :src="agmsUrlForCompany" @load="onLoadIframe" frameborder="0" width="0px" height="0px"
    v-if="agmsUrlForCompany"></iframe>
</template>

<script>
import Company from "./CompanyOverview/Company";
import Alert from "./CompanyOverview/Alert";
import KnownThreats from "./CompanyOverview/KnownThreats";
import ProtectedAgents from "./CompanyOverview/ProtectedAgents";
import Licences from "./CompanyOverview/Licences";
import AdminLicences from "./CompanyOverview/AdminLicences";
import Top5Groups from "./CompanyOverview/Top5Groups";
import Top5Computers from "./CompanyOverview/Top5Computers";
import BlocksOverTime from "./CompanyOverview/BlocksOverTime";
import { computed, defineComponent } from "vue";
import { useStore } from "../../../store";
import { mapState, mapActions, mapGetters } from "vuex";
import { Roles } from "@/helpers/enums/Roles";
import { useI18n } from "vue-i18n";
import moment from "moment";
import EventsTrend from "./CustomDashboard/EventsTrend";
import { AuthActionTypes } from "@/store/modules/auth/action-types";

export default defineComponent({
  name: "CompanyOverview",
  setup() {
    const store = useStore();
    const company = computed(() => store.getters.company);
    const { t, locale } = useI18n();
    const now = moment().utc().format("MM/DD/YYYY, HH:mm");


    return {
      company,
      now,
      t,
    };
  },
  data() {
    return {
      Roles: Roles,
      agmsUrlForCompany: null,
      partner: '',
    };
  },
  computed: {
    ...mapGetters(["site", "group", "loggedInUser"]),
  },
  components: {
    BlocksOverTime,
    Top5Computers,
    Top5Groups,
    Licences,
    AdminLicences,
    ProtectedAgents,
    KnownThreats,
    Company,
    Alert,
    EventsTrend
  },
  methods:
  {
    onLoadIframe() {
      this.agmsUrlForCompany = null;
    },
    ...mapActions({
      setCompany: AuthActionTypes.SET_COMPANY,
    }),
  },


  beforeMount() {
    if (this.loggedInUser.role != Roles.PartnerAdmin) {

      const company = JSON.parse(localStorage.getItem("company"));
      this.agmsUrlForCompany =
        process.env.VUE_APP_AGMS_URL +
        `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${company.companyGuid}`;
    } else {
      this.setCompany({});
    }
  },

  created() {

    if (this.loggedInUser.role == Roles.AGMSAdmin) {
      this.$router.push('/administration/manage-partners')
    }

    this.partner = JSON.parse(localStorage.getItem("partner"));
  },
});
</script>

<style scoped>
@media all and (max-width: 1680px) {
  div.dashboard-box {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
}

@media all and (max-width: 1360px) {
  div.dashboard-box {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media only screen and (max-width: 600px) {
  div.dashboard-box {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.now {
  color: #818181;
  font-size: 12px;
}
</style>
